require("../vendor/stickyfill.js");

module.exports = function() {
	var cart = document.querySelector('.cart');

	if(!cart) {
		return;
	}

	var form = cart.querySelector('.cart__form');
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/cart.js
 **/